import {Component, OnInit} from '@angular/core';
import {StateService} from "@uirouter/core";

import {MenuService, ParametersService, SubtitlesService, ZonesService} from "../../core";
import {AdditionalContact} from "../../models";

@Component({
    selector: 'additional-contact-card',
    templateUrl: './additional-contact-card.component.html',
    styleUrls: ['./additional-contact-card.component.scss']
})
export class AdditionalContactCardComponent implements OnInit {
    constructor(
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
        private menu: MenuService,
    ) {
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.zones.setOverflow();
    }
    goToZonesMenu(tile: AdditionalContact) {
        this.setSubmenuElementId(tile);
        this.zones.goToMenu(tile, tile.submenuElementId);
    }

    private setSubmenuElementId(tile: AdditionalContact) {
        this.menu.getElementMenu(tile.menuId); // menu element for tile
        this.menu.getMenuChildElement(this.menu.elementMenu) // set menu.submenu
        if (this.menu.submenu[0]) {
            tile.submenuElementId = this.menu.submenu[0].id;
        }
    }
}

